import { useState } from 'react';
import './index.css';
import { AuthProvider, useAuth } from './auth';
import LoginPage from './components/LoginPage';
import StepCustomer from './components/StepCustomer';
import StepTerms from './components/StepTerms';
import StepReview from './components/StepReview';
import StepSend from './components/StepSend';

const STEPS = [
  { label: 'Customer' },
  { label: 'Terms' },
  { label: 'Review' },
  { label: 'Send' },
];

const DEFAULT_DATA = {
  custName: '',
  custUen: '',
  custEmail: '',
  custPhone: '',
  custSigName: '',
  custSigTitle: '',
  billing: { attention: '', street1: '', street2: '', city: 'Singapore', zip: '', country: 'Singapore', phone: '' },
  pos: [{ name: '', addr: '' }],
  startDate: new Date().toISOString().split('T')[0],
  duration: '12',
  endDate: (() => { const d = new Date(); d.setMonth(d.getMonth() + 12); d.setDate(d.getDate() - 1); return d.toISOString().split('T')[0]; })(),
  creditTerm: '30',
  paymentMethod: 'credit card, bank transfer, and online payment as specified in the invoice',
  brands: ['Revitalash'],
  discount: '50',
  gstRegistered: false,
  sgSigName: 'Weijie',
  sgSigTitle: 'Director',
};

function StepDots({ current }) {
  return (
    <div className="steps">
      {STEPS.map((s, i) => {
        const n = i + 1;
        const isDone = n < current;
        const isActive = n === current;
        return (
          <div key={i} className="step">
            <div className={`step-dot${isActive ? ' active' : ''}${isDone ? ' done' : ''}`}>
              {isDone ? '✓' : n}
            </div>
            <div className={`step-label${isActive ? ' active' : ''}`}>{s.label}</div>
          </div>
        );
      })}
    </div>
  );
}

function ContractApp() {
  const { user, logout } = useAuth();
  const [step, setStep] = useState(1);
  const [formData, setFormData] = useState({ ...DEFAULT_DATA });

  if (!user) return <LoginPage />;

  return (
    <div className="app-shell">
      <nav className="topbar">
        <div className="topbar-brand">
          <div className="topbar-logo">
            <svg viewBox="0 0 24 24"><path d="M12 2C8.13 2 5 5.13 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.87-3.13-7-7-7zm0 9.5c-1.38 0-2.5-1.12-2.5-2.5s1.12-2.5 2.5-2.5 2.5 1.12 2.5 2.5-1.12 2.5-2.5 2.5z"/></svg>
          </div>
          <span className="topbar-name">Soft Glow</span>
          <span style={{ fontSize: 12, color: 'var(--muted)', marginLeft: 6 }}>Contract Portal</span>
        </div>
        <div className="topbar-right">
          <span className="topbar-user">Signed in as <strong>{user.name}</strong></span>
          <button className="btn-logout" onClick={logout}>Sign out</button>
        </div>
      </nav>

      <div className="page-content">
        <div className="container">
          <div className="page-header">
            <h2>New Commercial Agreement</h2>
            <p>Revitalash — Soft Glow Pte. Ltd.</p>
          </div>

          <StepDots current={step} />

          {step === 1 && (
            <StepCustomer
              data={formData}
              onChange={setFormData}
              onNext={() => setStep(2)}
            />
          )}
          {step === 2 && (
            <StepTerms
              data={formData}
              onChange={setFormData}
              onNext={() => setStep(3)}
              onBack={() => setStep(1)}
            />
          )}
          {step === 3 && (
            <StepReview
              data={formData}
              onNext={() => setStep(4)}
              onBack={() => setStep(2)}
            />
          )}
          {step === 4 && (
            <StepSend
              data={formData}
              onBack={() => setStep(3)}
              user={user}
            />
          )}
        </div>
      </div>
    </div>
  );
}

export default function App() {
  return (
    <AuthProvider>
      <ContractApp />
    </AuthProvider>
  );
}
